module.exports = __webpack_public_path__ + "img/question.816fb80a.svg";